// Search/highlight helpers — FXC-8538 (Warp).
//
// Lifted from Bobbin's `graph-utils.ts`. A renderer that wants to
// emphasise edges touching a highlight set (e.g. full-text-search hits)
// uses `edgeHitsHighlight`.

/**
 * True when either endpoint of an edge is in the highlight set.
 *
 * Force-graph layout mutates link endpoints from string ids into object
 * refs after the first tick, so this accepts both shapes — pass the
 * renderer's live link object straight through.
 */
export function edgeHitsHighlight(
  link: { source: unknown; target: unknown },
  ids: Set<string> | null | undefined,
): boolean {
  if (!ids) return false;
  const src =
    typeof link.source === "string"
      ? link.source
      : (link.source as { id?: string })?.id;
  const tgt =
    typeof link.target === "string"
      ? link.target
      : (link.target as { id?: string })?.id;
  return Boolean((src && ids.has(src)) || (tgt && ids.has(tgt)));
}
